export default __webpack_public_path__ + "static/media/coresanscr65it-webfont.dd985e01.woff2";